/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiCompanyRoomOutcomeConfigEntryFromJSON(json) {
    return StreemApiCompanyRoomOutcomeConfigEntryFromJSONTyped(json, false);
}
export function StreemApiCompanyRoomOutcomeConfigEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !exists(json, 'code') ? undefined : json['code'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'callSourceCodes': !exists(json, 'call_source_codes') ? undefined : json['call_source_codes'],
    };
}
export function StreemApiCompanyRoomOutcomeConfigEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'label': value.label,
        'call_source_codes': value.callSourceCodes,
    };
}
//# sourceMappingURL=StreemApiCompanyRoomOutcomeConfigEntry.js.map